import Image from 'next/image';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { Container, Typography, Box } from '@mui/material';
import { useStyles } from './styles';

const DynamicCircularCarousel = dynamic(() => import('components/CircularCarousel'));

const Props = {
  bgColorProp: PropTypes.string,
  showTitle: PropTypes.bool,
  borderRadiusProp: PropTypes.number,
  paddingTopProp: PropTypes.number,
};

const DefaultProps = {
  bgColorProp: '#7833FF',
  showTitle: true,
  borderRadiusProp: 0,
  paddingTopProp: 6,
};

const graphicalAbstracts = [
  {
    image: '/images/graphical-abstract-slide-1.jpg',
    alternative:
      'Como funciona a glândula pineal, o órgão enigmático que regula nosso sono. BBC News Brasil.',
    id: 1,
  },
  {
    image: '/images/graphical-abstract-slide-2.jpg',
    alternative:
      'Londono-Renteria, B., Cardenas, J. C., Troupin, A. & Colpitts, T. M. Natural Mosquito-Pathogen Hybrid IgG4 Antibodies in Vector-Borne Diseases: A Hypothesis. Frontiers in Immunology 7, 380 (2016)',
    id: 2,
  },
  {
    image: '/images/graphical-abstract-slide-3.jpg',
    alternative:
      'Cortabarria, A. S. de V. et al. In Utero Therapy for the Treatment of Sickle Cell Disease: Taking Advantage of the Fetal Immune System. From Cell Dev Biol 8, 624477 (2021).',
    id: 3,
  },
  {
    image: '/images/graphical-abstract-slide-4.jpg',
    alternative:
      "Scorza, F. A. et al. Sudden death in a rat model of Parkinson's disease. Clinics, 76, (2021)",
    id: 4,
  },
  {
    image: '/images/graphical-abstract-slide-5.jpg',
    alternative:
      'Rather, I. A., Lone, J. B., Bajpai, V. K. & Park, Y.-H. Zika Vírus Infection during Pregnancy and Congenital Abnormalities. Front Microbiol 8, 581 (2017).',
    id: 5,
  },
  {
    image: '/images/graphical-abstract-slide-6.jpg',
    alternative:
      'Babacic, H., Mehta, A., Merkel, O. & Schoser, B. CRISPR-cas gene-editing as plausible treatment of neuromuscular and nucleotide-repeat-expansio n diseases: A systematic review, PLos One 14, e0212198 (2019).',
    id: 6,
  },
];

export default function CarouselGraphicalAbstractsVariant({
  bgColorProp,
  showTitle,
  borderRadiusProp,
  paddingTopProp,
}) {
  const classes = useStyles();

  return (
    <Box
      pb={6}
      pt={paddingTopProp}
      bgcolor={bgColorProp}
      style={{ borderRadius: borderRadiusProp }}
    >
      <Container>
        {showTitle && (
          <Typography className={classes.whiteColor} variant="h2" align="center">
            <b>Published Graphical Abstracts made with Mind the Graph</b>
          </Typography>
        )}

        <DynamicCircularCarousel
          classes={{
            root: classes.carouselRoot,
            carousel: classes.carousel,
            carouselItem: classes.carouselItem,
          }}
          autoplay={true}
          controlButtons={false}
          items={graphicalAbstracts.map((graphicalAbstract) => (
            <Box key={graphicalAbstract.id}>
              <Image
                src={graphicalAbstract.image}
                width={344}
                height={231}
                alt={graphicalAbstract.alternative}
                loading="lazy"
                quality={100}
              />
            </Box>
          ))}
        />
      </Container>
    </Box>
  );
}

CarouselGraphicalAbstractsVariant.propTypes = Props;
CarouselGraphicalAbstractsVariant.defaultProps = DefaultProps;
